<p-dialog
[(visible)]="displayLocalizedValues"
[dismissableMask]="true"
[modal]="true"
[transitionOptions]="'200ms'"
[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
[style]="{ width: 'auto', minWidth: '50vw' }"
[contentStyle]="{ 'overflow': 'visible' }"
>
<ng-template pTemplate="header">
  <h3 class="p-m-0">Localized Values</h3>
</ng-template>

<div *ngIf="this.localizedValues" class="p-text-center" style="overflow: auto;">
  <p-table [value]="localizedValues" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>ID</th>
        <th *ngFor="let column of getColumns(localizedValues)">
          {{ column }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td style="text-align: justify;">{{ row.id }}</td>
        <td style="text-align: justify;" *ngFor="let column of getColumns(localizedValues)">
          {{ row[column] || 'N/A' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
</p-dialog>